// Footer.jsx - KisaanMart Footer
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../../../assets/css/components/general/footer/Footer.css";
import { baseUrl } from "../../../context/MyContext";

// ── FIXED: pehle "Our Products" column mein hardcoded subcategory
// names thi (Seeds, Fertilizers, ...) jo asal database ki subcategories
// se match na bhi karti hon — is se click karne par "no products found"
// wala khali page khul sakta tha. Ab koi hardcoded fallback nahi hai;
// sirf wahi subcategories dikhengi jo asal mein database se fetch hui
// hon, taake har link guaranteed kaam kare.
const Footer = () => {
  const navigate = useNavigate();
  const [productLinks, setProductLinks] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/customer/category/viewAllCategories`)
      .then((res) => {
        const categories = res.data?.categories;
        if (Array.isArray(categories) && categories.length > 0) {
          const flattened = [];
          categories.forEach((cat) => {
            (cat.kmsubcategories || []).forEach((sub) => {
              flattened.push({
                category: cat.categoryname,
                subcategory: sub.subcategoryname,
              });
            });
          });
          if (flattened.length > 0) {
            setProductLinks(flattened.slice(0, 6));
          }
        }
      })
      .catch(() => {
        // fetch fail ho jaye to list khali rahegi (koi fake/hardcoded
        // link nahi dikhaya jayega jo kisi asal product tak na le jaye)
      });
  }, []);

  // ✅ Navigate to ProductsPage with category + subcategory pre-selected
  const goToSubcategory = (category, subcategory) => {
    navigate("/products", {
      state: { category, subcategory },
    });
  };

  return (
    <footer className="footer1">
      <Container>
        <Row className="footer-content1">
          {/* Column 1: About */}
          <Col xs={12} md={6} lg={4} className="mb-4">
            <div className="footer-logo1">
              <div className="logo-icon1">
                <span className="logo-text1">K</span>
              </div>
              <div className="brand-name1">
                <span className="brand-main1">KisaanMart</span>
                <span className="brand-tagline1">Agriculture Marketplace</span>
              </div>
            </div>
            <p className="footer-text1">
              Pakistan's most trusted online agriculture marketplace providing
              quality products
            </p>
            {/* <div className="social-icons">
              {[
                { Icon: FaFacebookF, href: "https://facebook.com",  cls: "facebook"  },
                { Icon: FaTwitter,   href: "https://twitter.com",   cls: "twitter"   },
                { Icon: FaInstagram, href: "https://instagram.com", cls: "instagram" },
  
              ].map(({ Icon, href, cls }) => (
                <a key={cls} href={href} target="_blank" rel="noopener noreferrer" className={`social-icon ${cls}`}>
                  <Icon />
                </a>
              ))}
            </div> */}
          </Col>

          {/* Column 2: Quick Links */}
          <Col xs={6} md={6} lg={2} className="mb-4">
            <h4 className="footer-heading1">Quick Links</h4>
            <ul className="footer-links1">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/shops">Shops</Link>
              </li>
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/blogs">Blog</Link>
              </li>
            </ul>
          </Col>

          {/* Column 3: Our Categories — ✅ asal categories/subcategories se fetch hota hai;
              agar kuch na mile to poora column hide ho jata hai */}
          {productLinks.length > 0 && (
            <Col xs={6} md={6} lg={3} className="mb-4">
              <h4 className="footer-heading1">Our Categories</h4>
              <ul className="footer-links1">
                {productLinks.map(({ category, subcategory }) => (
                  <li key={`${category}-${subcategory}`}>
                    <span
                      onClick={() => goToSubcategory(category, subcategory)}
                      style={{ cursor: "pointer" }}
                    >
                      {subcategory}
                    </span>
                  </li>
                ))}
              </ul>
            </Col>
          )}

          {/* Column 4: Contact */}
          <Col xs={12} md={6} lg={3} className="mb-4">
            <h4 className="footer-heading1">Contact Us</h4>
            <div className="contact-info1">
              <div className="contact-item1">
                <FaMapMarkerAlt className="contact-icon1" />
                <span>Gujranwala, Punjab, Pakistan</span>
              </div>
              {/* <div className="contact-item1">
                <FaPhone className="contact-icon1" />
                <span>+92-3</span>
              </div>  */}
              <div className="contact-item1">
                <FaEnvelope className="contact-icon1" />
                <span>kisaanmart2@gmail.com</span>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <Row>
          <Col
            xs={12}
            md={6}
            className="text-center text-md-start mb-3 mb-md-0"
          >
            <p className="footer-copyright">
              © 2025 KisaanMart. All rights reserved.
            </p>
          </Col>
          <Col xs={12} md={6} className="text-center text-md-end">
            <p className="footer-copyright">
              <Link to="/privacy">Privacy Policy</Link> |
              <Link to="/terms"> Terms of Service</Link> |
              <Link to="/refund"> Refund Policy</Link>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
